import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operationProcedureComponent from './operation-procedure.component';

let operationProcedureModule = angular
  .module('operation-procedure', [uiRouter])
  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newOperationProcedure', {
        url: '/operation-procedure/new',
        component: 'operationProcedure',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editOperationProcedure', {
        url: '/operation-procedure/:id',
        component: 'operationProcedure',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          operationProcedure: (OperationProceduresService, $stateParams) =>
            OperationProceduresService.findById($stateParams.id)
        }
      });
  })
  .component('operationProcedure', operationProcedureComponent).name;

export default operationProcedureModule;
